import { OptionGroup } from '@core/interfaces/option-group';
import EntityFormProvider from '@shared/components/forms/auto-form/entity-form-provider/entity-form-provider.vue';
import StdForm from '@shared/components/forms/auto-form/std-form/std-form.vue';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import EntityExportOptionsForm from '../entity-export-options-form/entity-export-options-form.vue';

@Component({
  name: 'bpc-option-group-form',
  components: {
    'bpc-std-form': StdForm,
    'bpc-entity-export-options-form': EntityExportOptionsForm,
  },
})
export default class OptionGroupForm extends Vue {
  $refs: {
    // resourceForm: InstanceType<typeof ResourceForm> & { saveEntity(): void };
    stdForm: InstanceType<typeof StdForm> & {
      saveEntity(): void;
      formModel: any;
      onDeleteMediaFile(): void;
      searchEntity(): void;
      extraData: string | AnyEntity;
      formProvider: EntityFormProvider;
    };
  };
  @Prop(String) readonly entity: string;
  @Prop([Object]) readonly value: OptionGroup;
  @Prop({ type: String, default: 'default' }) formConfigName: string;
  @Prop({ type: Boolean, default: false }) disabled: string;
  @Prop(Boolean) showForm: boolean;
  @Prop(String) readonly permissionEntityName: string;

  get formModel(): OptionGroup {
    return this.value;
  }

  set formModel(value) {
    this.$emit('input', value);
  }

  get entityId(): number {
    return this.formModel?.id ? Number(this.formModel.id) : null;
  }

  get entityType(): string {
    return this.formModel?.entity_type || null;
  }

  public i = 0;

  // created() {}
  mounted() {
    /* this.$root.$on('changeActivityType', val => {
      this.$refs.stdForm.formModel.articleBookingDetail = null;
    }); */
  }

  destroyed() {
    /* this.$root.$off('changeActivityType'); */
  }

  onFormSaved(e) {
    this.$emit('entity-saved', e);
  }
  onSavingEntity(event) {
    this.$emit('saving-entity', event);
  }
  deleteMediaFile(mediaId) {
    this.$emit('delete-media-file', { mediaId: mediaId, entityId: this.entityId });
  }
  saveEntity() {
    this.$refs.stdForm.saveEntity();
  }

  @Watch('entityType')
  onEntityTypeChange(val, oldVal) {
    if (oldVal && val) {
      this.formModel.options = null;
    }
  }

  // @Watch('formModel', { immediate: true, deep: true })
  // onFormModelChange() {
  //   this.$emit('input', this.formModel);
  // }
}
